const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.2824 18.8558H21.1395V6.28435H17.7109V4.57007H6.85379V6.28435H2.85379V18.8558H1.71094V19.9986H22.2824V18.8558ZM7.99665 5.71293H16.5681V7.99864H7.99665V5.71293ZM7.42522 18.8558L7.41825 11.9986H9.71094V18.8558H7.42522ZM10.8538 18.8558V11.9986H13.1395V18.8558H10.8538ZM14.2824 18.8558V11.9986H16.5681V18.8558H14.2824ZM17.7109 18.8558V11.9986C17.7105 11.6957 17.59 11.4052 17.3757 11.191C17.1615 10.9767 16.8711 10.8562 16.5681 10.8558H7.41825C7.11715 10.8561 6.82847 10.9759 6.61553 11.1887C6.40259 11.4016 6.28277 11.6903 6.28237 11.9914V18.8558H3.99665V7.42721H6.85379V9.1415H17.7109V7.42721H19.9967V18.8558H17.7109Z",
    style: {
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/Store.67b808ea6952b88f5319f7b66874ae10.svg";
export { ForwardRef as ReactComponent };